<script>
    import { onMount, tick } from 'svelte';

    import Button from './Button.svelte';
    import Reviews4Item from './Reviews4Item.svelte';
    import { get_is_admin } from './utils/is_admin';

    export let reviews = [];
    /** @type {Product | null} */
    export let product = null;

    let className = '';
    export { className as class };
    export let review_class = '';

    export let invert = false;

    const is_admin = get_is_admin();
    let is_admin_value = false;
    is_admin.then((v) => (is_admin_value = v || false));
    let reviews_key = 0;
    let show_all = false;
    let reviews_el;
    let can_collapse = true;
    let measure_request = 0;

    const measure_collapse = async () => {
        const current_request = ++measure_request;
        if (show_all) return;

        can_collapse = true;
        await tick();

        if (current_request !== measure_request || show_all || !reviews_el) {
            return;
        }

        can_collapse = reviews_el.scrollHeight > reviews_el.clientHeight + 1;
    };

    $: should_collapse = !show_all && can_collapse;
    $: measure_key = [
        reviews_key,
        reviews?.length || 0,
        className,
        review_class,
        is_admin_value
    ].join(':');
    $: if (!show_all && measure_key) measure_collapse();

    onMount(() => {
        measure_collapse();

        window.addEventListener('resize', measure_collapse);

        return () => window.removeEventListener('resize', measure_collapse);
    });

    const handle_priority_change = (event) => {
        if (!is_admin_value) return;
        const { id, priority } = event.detail || {};
        if (!id) return;

        reviews = reviews
            .map((r) => (r.id === id ? { ...r, priority } : r))
            .sort((a, b) => {
                const a_p = a.priority ?? 0;
                const b_p = b.priority ?? 0;
                if (a_p !== b_p) return a_p - b_p;
                return b.created_at > a.created_at ? -1 : 1;
            });
        reviews_key += 1;
    };
</script>

{#key reviews_key}
    <div
        bind:this={reviews_el}
        class={should_collapse
            ? 'overflow-hidden overflow-gradient-b-xl max-h-150 md:max-h-200'
            : ''}
    >
        <div
            class={`grid gap-8 lg:grid-cols-2 xl:grid-cols-3 ${className}`.trim()}
        >
            {#each reviews as review}
                <Reviews4Item
                    {review}
                    {invert}
                    class={`h-full ${review_class}`.trim()}
                    show_for={!product}
                    on:priorityChange={handle_priority_change}
                />
            {/each}
        </div>
    </div>
    {#if should_collapse}
        <div class="flex justify-center">
            <Button outline on:click={() => (show_all = true)}>
                Show More
            </Button>
        </div>
    {/if}
{/key}
